import styled from 'styled-components';

export const Container = styled.section`
  margin: 1.8125rem 0;
`;
